import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const ManageGradProgramPageContainerLoadable = clientOnlyLazy({
  loader: () => import('./ManageGradProgramPageContainer.dynamic'),
  loading: LoadableLoadingSection,
});
